import { ALTERNATIVE_UNIT_TYPE_TO_UNIT_TYPE } from '@/constants/hor'

export const isAlternativeUnitTypeSameAsUnitType = (
  alternativeUnitTypeConsidered: string,
  bedrooms: number | number[]
) => {
  if (alternativeUnitTypeConsidered === null) return false
  const alternativeUnitTypeIsUnitTypeValue =
    ALTERNATIVE_UNIT_TYPE_TO_UNIT_TYPE[alternativeUnitTypeConsidered]
  if (Array.isArray(bedrooms)) {
    return bedrooms.some(
      (bedroom) => bedroom === alternativeUnitTypeIsUnitTypeValue
    )
  }
  return bedrooms === alternativeUnitTypeIsUnitTypeValue
}
